import cookie from "react-cookies";
import { ROLE } from "../constants/constants";

export const getAuthHeaders = () => {
  const token = cookie.load("token");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

export const decodeToken = (token) => {
  try {
    const payload = token.split(".")[1];
    return JSON.parse(atob(payload));
  } catch (err) {
    console.error("Invalid token:", err);
    return null;
  }
};

export const getRedirectByRole = (role) => {
  const r = role?.toLowerCase();
  if (r === ROLE.ADMIN?.toLowerCase()) return "/admin/users";
  if (r === ROLE.USER?.toLowerCase()) return "/meetings";
  return "/sign-in";
};

export const saveAuthToken = (token) => {
  const ACCESS_TOKEN_VALIDITY_MINUTES =
    Number(process.env.REACT_APP_ACCESS_TOKEN_VALIDITY_MINUTES) || 60 * 24 * 7;

  const ACCESS_TOKEN_VALIDITY_SECONDS = ACCESS_TOKEN_VALIDITY_MINUTES * 60;

  if (!token) return;

  cookie.save("token", token, {
    path: "/",
    maxAge: ACCESS_TOKEN_VALIDITY_SECONDS,
    secure: process.env.NODE_ENV === "production",
    sameSite: "strict",
  });
};

export const getRedirectPath = ({ role, isOnboardingCompleted }) => {
  if (role === ROLE.ADMIN) return "/admin/users";

  if (role === ROLE.USER) {
    if (isOnboardingCompleted) {
      return "/meetings";
    } else {
      return "/onboarding/source";
    }
  }

  return "/";
};
